import { Button, Col, DatePicker, PageHeader, Row } from "antd";

import { Fragment, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useMediaQuery } from "react-responsive";

import { useHistory, useParams } from "react-router-dom";
import { setBlurModal } from "../../core/store/reducers/settings.slice";
import { RootState } from "../../shared/constants";
import TableLayout from "../../shared/layouts/table.layout";
import { allTableConfigs } from "./components/config";
import UploadFileComponent from "./components/upload-file.component";
import { fetchTicketsList } from "../../core/store/reducers/tickets.slice";
import { getFilesCategories } from "../../core/store/reducers/files.slice";
const { RangePicker } = DatePicker;

function FileConfigurationPage() {
  const dispatch = useDispatch();
  const params: any = useParams();
  const history = useHistory();
  const { master_dropdown } = useSelector((state: RootState) => state.settings);
  const { loading_tickets, tickets, contact_roles } = useSelector(
    (state: RootState) => state.tickets
  );
  const [uploadFileVisible, setUploadFileVisible] = useState(false as any);
  const [listData, setListData] = useState([] as any);
  const [listDataOrg, setListDataOrg] = useState([] as any);

  // Actions and selections
  const [formElements, setFormElements] = useState([] as any);
  const [columns, setColumns] = useState([] as any);
  const [statusList, setStatusList] = useState([] as any);
  const [filters, setFilters] = useState({ type: "self" } as any);
  const [sorters, setSorters] = useState({
    sort_column: "created_at",
    sort_val: null,
  } as any);
  const pagination = { offset: 0, limit: 10, total: listData?.length }
  const screenType = {
    desktop: useMediaQuery({ minWidth: 992 }),
    tablet: useMediaQuery({ minWidth: 768, maxWidth: 991 }),
    mobile: useMediaQuery({ maxWidth: 767 }),
  };

  useEffect(() => {
    loadList()
  }, []);
  useEffect(() => {
    if (listData)
      setColumns(allTableConfigs["file-configuration"].columns(history));
      setFormElements({
        onFinish: () => {},
        onFinishFailed: () => {},
        onValuesChange: filterFormSubmit,
        initialValues: { ...filters },
        filtersApplied: filters
          ? Object.keys(
              Object.fromEntries(
                Object.entries(filters).filter(([_, v]) => v != null)
              )
            ).length
          : 0,
        setValues: {
          ...filters,
        },
        formElements: allTableConfigs["file-configuration"].filterForm(listDataOrg?.map((val:any)=>{
          return {value: val.id, name: val.file_category}
        })),
      });
    }
  , [listDataOrg]);

  const loadList = (offset: number = 0) => {
    // let filter = {};
    // if (filters?.role && filters?.contact_ids) {
    //   filter = { contact_id: filters?.contact_ids };
    // }
    // let sorterData = {
    //   ...sorters,
    //   sort_val: sorters?.sort_val ? sorters?.sort_val : "asc",
    // };
    dispatch(
      getFilesCategories({
        // ...pagination,
        // offset: offset,
        // // status_id: selectedStatus,
        // ...filter,
        // ...sorterData,
      })
    ).then((val:any)=>{
      if(val?.payload?.data?.data){
        setListData(val?.payload?.data?.data)
        setListDataOrg(val?.payload?.data?.data)
      }
    });
  };
  async function filterFormSubmit(changed: any, all: any) {
    setFilters(all);
    let tempList = JSON.parse(JSON.stringify(listDataOrg));
    if(all.search){
      tempList = tempList.filter((val:any)=>val.file_category.toLowerCase().includes(all.search.toLowerCase()))
    }
    if(all.file_category){
      tempList = tempList.filter((val:any)=>val.id == all.file_category)
    }
    setListData(tempList)
  }

  const onPageChange = (e: any, pageSize: any) => {
    let offset = (e - 1) * pagination.limit;
    loadList(offset);
  };
  useEffect(() => {
    dispatch(setBlurModal(uploadFileVisible));
  }, [uploadFileVisible]);

  return (
    <Fragment>
      <PageHeader
        ghost={false}
        title={
          <Row
            style={screenType.mobile ? { paddingLeft: "25px" } : {}}
            align="middle"
          >
            <Col className="title-text">File Configuration</Col>
          </Row>
        }
        extra={
          <Row align="middle">
            <Col className="title-text">
              <Button
                key="1"
                className="ant-btn-hover"
                onClick={() => {
                  setUploadFileVisible(true);
                }}
              >
                Upload File
              </Button>
            </Col>
          </Row>
        }
      ></PageHeader>

      <Row className="content-area pt-4">
        <Col span={24}>
          {columns && formElements && (
            <TableLayout
              defaultCurrentPage={pagination.offset / pagination.limit + 1}
              loading={loading_tickets}
              buttonEvt={() => {}}
              dataSource={listData}
              filters="multiple"
              columns={columns}
              onChange={(e, ee) => onPageChange(e, ee)}
              type="morefilters"
              total={pagination.total}
              showTotal={true}
              pagination={{
                position: ["none", "none"],
                pageSize: pagination.limit,
              }}
              paginationPosition="top"
              formData={formElements}
              maxWidth={1000}
              defaultPageSize={10}
              showSizeChangerFlag={false}
            />
          )}
        </Col>
      </Row>
      {uploadFileVisible && (
        <UploadFileComponent
          formVisible={uploadFileVisible}
          setFormVisible={setUploadFileVisible}
          reloadList={()=>{}}
        />
      )}
    </Fragment>
  );
}

export default FileConfigurationPage;
